import { useEffect, useRef, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import capitalizeWords from "../../helperFunctions/capitalizedWords";

export default function ProductTabs({
  products = [],
  activeProduct,
  setActiveProduct,
  CostCalculator,
}) {
  const scrollRef = useRef(null);
  const itemRefs = useRef([]); // store refs for each product tab

  const [currentIndex, setCurrentIndex] = useState(null);

  const scrollTabs = (direction) => {
    if (scrollRef.current) {
      // Get width of one tab
      const tabWidth =
        scrollRef.current.querySelector(".product-tab")?.offsetWidth || 0;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -tabWidth : tabWidth,
        behavior: "smooth",
      });
    }
  };

  const onHandleLeft = () => {
    if (currentIndex > 0) {
      let index = currentIndex - 1;
      setCurrentIndex(index);

      setActiveProduct(products[index]);
    }
  };
  useEffect(() => {
    if (itemRefs.current[currentIndex]) {
      itemRefs.current[currentIndex].scrollIntoView({
        behavior: "smooth",
        inline: "center", // ensures it scrolls horizontally
        block: "nearest",
      });
    }
  }, [currentIndex, activeProduct]);
  const onHandleRight = () => {
    if (currentIndex < products?.length - 1) {
      let index = currentIndex + 1;
      setCurrentIndex(index);

      setActiveProduct(products[index]);
    }
  };

  return (
    <div className="flex items-center justify-start bg-white mx-6 mt-6 p-2  ">
      {/* Left Button */}
      {activeProduct && (
        <button
          onClick={() => onHandleLeft()}
          className={`z-10 bg-[#1976d2] shadow-md rounded-full flex items-center justify-center border border-1 w-8 h-8 ${
            currentIndex <= 0
              ? "cursor-not-allowed bg-gray-300"
              : "cursor-pointer"
          }  `}
        >
          <div className="ml-1.5">
            <ArrowBackIosIcon
              fontSize="small"
              sx={{
                color: "white",
              }}
            />
          </div>
        </button>
      )}

      {/* Scrollable Tabs */}
      <div
        ref={scrollRef}
        className="flex overflow-x-auto mx-2  w-full flex-col md:flex-row sm:max-w-2xl md:max-w-4xl lg:max-w-5xl xl:max-w-6xl 2xl:max-w-7xl p-2 border-1 border shadow-md rounded-md bg-gray-100 "
        style={{
          scrollBehavior: "smooth",
          msOverflowStyle: "none", // IE/Edge
          scrollbarWidth: "none", // Firefox
        }}
      >
        {/* {Array.isArray(products) &&
          products?.map((type, index) => (
            <div
              key={index}
              ref={(el) => (itemRefs.current[index] = el)} // assign ref
              onClick={() => {
                setActiveProduct(type);
                setCurrentIndex(index);
              }}
              className={`product-tab px-6 py-3 text-center cursor-pointer text-sm font-medium mr-2 rounded-md
              ${
                activeProduct === type
                  ? "bg-[#1976d2] text-white shadow-blue-300 shadow-sm"
                  : "text-gray-500 hover:bg-gray-400 bg-white hover:text-white"
              }
            `}
              style={{
                border:
                  activeProduct === type
                    ? "1px solid #1976d2"
                    : "1px solid #ccc",
                borderBottom:
                  activeProduct === type ? "none" : "1px solid #ccc",
                flexShrink: 0, // Prevent shrinking when more products added
              }}
            >
              {type}
            </div>
          ))} */}
        {Array.isArray(products) &&
          products?.map((type, index) => {
            const totalCost =
              CostCalculator?.[index]?.costCalculator?.totalCostOfProduct > 0 ||
              CostCalculator?.[index]?.costCalculator?.regionWiseCosts.every(
                (r) => r.totalCostOfProduct != "" && r.totalCostOfProduct > 0,
              )
                ? true
                : false;

            return (
              <div
                key={index}
                ref={(el) => (itemRefs.current[index] = el)}
                onClick={() => {
                  setActiveProduct(type);
                  setCurrentIndex(index);
                }}
                className={`relative product-tab px-6 py-3 text-center cursor-pointer text-sm font-medium mr-2 rounded-md
        ${
          activeProduct === type
            ? "bg-[#1976d2] text-white shadow-blue-300 shadow-sm"
            : "text-gray-500 hover:bg-gray-400 bg-white hover:text-white"
        }`}
                style={{
                  border:
                    activeProduct === type
                      ? "1px solid #1976d2"
                      : "1px solid #ccc",
                  borderBottom:
                    activeProduct === type ? "none" : "1px solid #ccc",
                  flexShrink: 0,
                }}
              >
                {capitalizeWords(type)}

                {/* Dot indicator */}
                {localStorage.getItem("role") != "1" && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-5px", // tailwind top-1
                      right: "-5px", // tailwind right-1
                      width: "12px", // tailwind w-3
                      height: "12px", // tailwind h-3
                      borderRadius: "50%",
                      border: "1px solid white",
                      backgroundColor: totalCost ? "#68a468" : "#e86d6d",
                      animation: "pulse 1.5s infinite",
                    }}
                  />
                )}
              </div>
            );
          })}
      </div>

      {/* Right Button */}
      {activeProduct && (
        <button
          onClick={() => onHandleRight()}
          className={`z-10 bg-[#1976d2] shadow-md rounded-full  border border-1 w-8 h-8 flex items-center justify-center  ${
            currentIndex < products?.length - 1
              ? "cursor-pointer"
              : "cursor-not-allowed bg-gray-300"
          }`}
        >
          <ArrowForwardIosIcon
            fontSize="small"
            sx={{
              color: "white",
            }}
          />
        </button>
      )}
    </div>
  );
}
